import { defineComponent as _defineComponent } from 'vue'
import { WorkOrder, WORK_ORDER_STATUS } from '@newmoon-org/types';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkOrderListCard',
  props: {
    workOrder: null
  },
  setup(__props: any) {

const props = __props as {
  workOrder: WorkOrder;
}

const declinedStatuses = [WORK_ORDER_STATUS.DECLINE_ON_BOOKING, WORK_ORDER_STATUS.DECLINED];
const delayedStatuses = [WORK_ORDER_STATUS.DELAYED];



const showReasonForDecline = computed(() => {
  return declinedStatuses.includes(props.workOrder.status) && !!props.workOrder.reasonForDecline;
});
const showReasonForDelay = computed(() => {
  return delayedStatuses.includes(props.workOrder.status) && !!props.workOrder.reasonForDelay;
});

return { __sfc: true,declinedStatuses, delayedStatuses, props, showReasonForDecline, showReasonForDelay }
}

})